import layout from '@/layout'

export default {
  path: '/application',
  component: layout,
  redirect: '/application/expire',
  name: 'expire',
  meta: {
    title: '应用管理',
    icon: 'application'
  },
  children: [
    {
      path: '/application/expire',
      component: () => import('@/views/application/expire'),
      meta: {
        title: '到期提醒',
        icon: 'file-date'
      }
    }
  ]
}
